import lottie from 'lottie-web';

export default {
  init() {
     $(document).ready(function() {
	if ($('div.row .animated.fadeInUp').length) {
		// CTA box exists, check it has content first (sometimes they are blank?)
		if ($('div.row .animated.fadeInUp').text().trim().length > 5) { // covers any accidental blank spaces or whatever
			// add the class#
			$('section#main-title-and-intro').addClass('withCTA');
		}
	}
});
    
    //hs
$(document).ready(function () {
    // Select the container using jQuery
    const targetContainer = $('#newsletter'); // Replace with your actual container selector

    // Ensure the container exists
    if (targetContainer.length) {
        const nativeNode = targetContainer[0]; // Get the native DOM Node

        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === 1) { // Ensure it's an element node
                        // Look for the nested target element
                        const submitButton = $(node).find('input.hs-button.primary.large[type="submit"]').not('.wrapped');

                        if (submitButton.length) {
                            console.log('Submit button found and wrapped');
                            submitButton.addClass('wrapped'); // Add marker class to prevent re-wrapping
                            submitButton.wrap('<div class="p-btn-dark"><div class="findout"></div></div>');
                        }
                    }
                });
            });
        });

        // Start observing with `subtree` enabled
        observer.observe(nativeNode, { childList: true, subtree: true });
    } else {
        console.error('Target container #newsletter not found.');
    }
});
 
//mobile menu
        $('header .mobile-menu').on('click', function() {
          if($('.mobile-menu').hasClass('open')) {
            $(this).find('#menu').toggleClass('open');
          $('.mobile-menu').removeClass('open');
          $('.nav-mobile').removeClass('show');
          }
          else {
            $(this).find('#menu').toggleClass('open');
        $('.mobile-menu').addClass('open');
          $('.nav-mobile').addClass('show');
          }
        });


    // mobile menu expand
    
       $('#menu-mobile-menu .menu-item-has-children > a').click(function(){
     
		$(this).parent().toggleClass('expand');
	});
    // end mobile menu expand
    
// end mobile menu
  /*  $(document).ready(function () {
      var iFrameID = document.getElementById('booking-module');
console.log(iFrameID);
      console.log('la');
      console.log(iFrameID.scrollHeight);
 setInterval(function(){
if(iFrameID.scrollHeight == iFrameID.contentWindow.document.body.scrollHeight){
   //  clearInterval(intval);
}else{
   iFrameID.height = iFrameID.contentWindow.document.body.scrollHeight + 'px';
  }
},500);

    });*/
    
    // submit button forms
/*    $(document).ready(function () {
  $('.submit-me').unbind().click(function () {
    console.log('was clicked');
    $('.wpcf7-form-control').trigger('click');
  });
       });
*/    // end submit button forms
    
    
$(document).ready(function () {
  var $update;
    var w = window.innerWidth;  
   
   
    if (w >= 1136) {
    $('.menu-item-63, .menu-item-10296, .menu-item-10304, .menu-item-10307, .menu-item-66, .menu-item-10311, .menu-item-10309').mouseenter(

      function () {
      console.log('add');
        $('.menu-item').removeClass('active');
        $(this).addClass('active');
      $update = $(this);
      });
      $('header').mouseleave(function () {
        console.log('d');
        $update.removeClass('active');
      }
    );
    }
  });
         $( document ).ready(function() {
      var $slick = $('.hero-carousel');
$slick.slick({
  //  autoplay: true,
    dots: true,
  slidesToShow: 1,
  slidesToScroll: 1,
 autoplay: true,
 //  infinite: true,
 // fade: true,
 centerMode: false,
  arrows: true,
  infinite: true,
  // centerPadding: '20%',
    speed: 800,
  autoplaySpeed: 3000,
   prevArrow: '<a class="slick-prev prev" href="#"><div class="ani-arrow back"></div></a>',
  nextArrow: '<a class="slick-next next" href="#"><div class="ani-arrow"></div></a>',
    responsive: [{ 
        breakpoint: 1200,
        settings: {
            slidesToShow: 1,
          centerMode: false,
        },
    }],
}).slickAnimation();
       
             var $slickNews = $('.news-carousel');
$slickNews.slick({
  //  autoplay: true,
    dots: true,
  slidesToShow: 1,
  slidesToScroll: 1,
 // autoplay: true,
 //  infinite: true,
 centerMode: false,
  arrows: true,
  infinite: true,
  centerPadding: '20%',
    speed: 1000,
   prevArrow: '<a class="slick-prev prev" href="#"><div class="ani-arrow back"></div></a>',
  nextArrow: '<a class="slick-next next" href="#"><div class="ani-arrow"></div></a>',
    responsive: [{ 
        breakpoint: 1136,
        settings: {
            slidesToShow: 1,
          centerMode: false,
        },
    },
                { 
        breakpoint: 767,
        settings: {
            slidesToShow: 1,
         arrows: false,
          dots: true,
          infinite: false,
         // centerMode: false,
        },
       
    }],
})
           .on('setPosition', function (event, slick) {
    slick.$slides.css('height', slick.$slideTrack.height() + 'px');
});

           
           var $slickThreeCol = $('.three-col-carousel');
$slickThreeCol.slick({
  //  autoplay: true,
    dots: false,
  slidesToShow:  3,
  slidesToScroll: 1,
 // autoplay: true,
 //  infinite: true,
 //centerMode: true,
  arrows: true,
  infinite: false,
    speed: 1000,
   prevArrow: '<a class="slick-prev prev" href="#"><div class="ani-arrow back"></div></a>',
  nextArrow: '<a class="slick-next next" href="#"><div class="ani-arrow"></div></a>',
    responsive: [{ 
        breakpoint: 1136,
        settings: {
            slidesToShow: 2,
         // centerMode: false,
        },
       
    },
                { 
        breakpoint: 767,
        settings: {
            slidesToShow: 1,
          dots: true,
         // centerMode: false,
        },
       
    }],
});
           
           var $slickFourCol = $('.four-col-carousel');
$slickFourCol.slick({
  //  autoplay: true,
    dots: false,
  slidesToShow:  4,
  slidesToScroll: 1,
 // autoplay: true,
 //  infinite: true,
 //centerMode: true,
  arrows: true,
  infinite: false,
    speed: 1000,
   prevArrow: '<a class="slick-prev prev" href="#"><div class="ani-arrow back"></div></a>',
  nextArrow: '<a class="slick-next next" href="#"><div class="ani-arrow"></div></a>',
    responsive: [{ 
        breakpoint: 1136,
        settings: {
            slidesToShow: 2,
          centerMode: false,
        },
    },
                { 
        breakpoint: 767,
        settings: {
            slidesToShow: 1,
         arrows: false,
          dots: true,
         // centerMode: false,
        },
       
    }],
});
             
           var $slickPGA = $('.pga-carousel');
$slickPGA.slick({
  //  autoplay: true,
    dots: false,
  slidesToShow: 5.3,
  slidesToScroll: 1,
 // autoplay: true,
 //  infinite: true,
 //centerMode: true,
 // rtl: true,
  arrows: true,
  infinite: false,
  centerPadding: '20%',
    speed: 1000,
   prevArrow: '<a class="slick-prev prev" href="#"><div class="ani-arrow back"></div></a>',
  nextArrow: '<a class="slick-next next" href="#"><div class="ani-arrow"></div></a>',
    responsive: [{ 
        breakpoint: 1136,
        settings: {
            slidesToShow: 3,
         // centerMode: false,
        },
    },
      { breakpoint: 767,
        settings: {
            slidesToShow: 1.5,
          dots: true,
         // centerMode: false,
        },
         }],
});
       
              var $slickInner = $('.inner.carousel .images');
$slickInner.slick({
  //  autoplay: true,
    dots: true,
  slidesToShow: 1,
  slidesToScroll: 1,
 autoplay: true,
 //  infinite: true,
 // fade: true,
 centerMode: false,
  arrows: true,
  infinite: true,
  // centerPadding: '20%',
    speed: 1000,
  autoplaySpeed: 5000,
   prevArrow: '<a class="slick-prev prev" href="#"><div class="ani-arrow back"></div></a>',
  nextArrow: '<a class="slick-next next" href="#"><div class="ani-arrow"></div></a>',
    responsive: [{ 
        breakpoint: 1200,
        settings: {
            slidesToShow: 1,
          centerMode: false,
        },
    },
                { 
        breakpoint: 767,
        settings: {
            slidesToShow: 1,
          centerMode: false,
          arrows: false,
          dots: true,
        },
    }],
}).slickAnimation();
     });
    
    
    var $slickTV = $('.channel-content');
$slickTV.slick({
  //  autoplay: true,
    dots: false,
  slidesToShow:  4,
  slidesToScroll: 1,
 // autoplay: true,
 //  infinite: true,
 //centerMode: true,
  arrows: true,
  infinite: false,
    speed: 1000,
   prevArrow: '<a class="slick-prev prev" href="#"><div class="ani-arrow back"></div></a>',
  nextArrow: '<a class="slick-next next" href="#"><div class="ani-arrow"></div></a>',
    responsive: [{ 
        breakpoint: 1136,
        settings: {
            slidesToShow: 2,
          centerMode: false,
        },
    }],
});

    $( document ).ready(function() { 
              
var $slickYouTube = $('.sby_items_wrap');
$slickYouTube.slick({
  //  autoplay: true,
    dots: false,
  slidesToShow:  4,
  slidesToScroll: 1,
 // autoplay: true,
 //  infinite: true,
 //centerMode: true,
  arrows: true,
  infinite: false,
    speed: 1000,
   prevArrow: '<a class="slick-prev prev" href="#"><div class="ani-arrow back"></div></a>',
  nextArrow: '<a class="slick-next next" href="#"><div class="ani-arrow"></div></a>',
    responsive: [{ 
        breakpoint: 1136,
        settings: {
            slidesToShow: 2,
          centerMode: false,
        },
    },
                { 
        breakpoint: 767,
        settings: {
            slidesToShow: 1,
      //   arrows: false,
      //    dots: true,
         // centerMode: false,
        },
       
    }],
});
      });
  /* let findout = document.querySelector('.findout');

    let findoutmore = lottie.loadAnimation({
            container: findout,
            renderer: 'svg',
            loop: false,
            autoplay: false,
            path: '/wp-content/uploads/json/FindOutMore_Btn_Trans_New.json',
    });

    var directionFind = 1;
      findout.addEventListener('mouseenter', () => {
      findoutmore.setDirection(directionFind);
      findoutmore.play();
    });

      findout.addEventListener('mouseleave', () => {
      findoutmore.setDirection(-directionFind);
      findoutmore.stop();
    }); */
    
    
   /* // Vars
var findout = $('.findout');

// Loop through steps
findout.each( function(){
      
    // Find animation for this step
  //  var animation = $(this).find('.animation');
    // Convert from jQuery to vanilla js for use with lottie-web
   // var anim = animation.get(0);

    // Lottie animation (vanilla js)
    var findoutmore = lottie.loadAnimation({
        container: findout,
        renderer: 'svg',
        loop: false,
        autoplay: false, // Don't autoplay, so we can play at desired time
        path: '/wp-content/uploads/json/FindOutMore_Btn_Trans_New.json',
    });

    // Play animation
 //   lottie.play(); // Plays all, but should only play current animation
var directionFind = 1;
      findout.addEventListener('mouseenter', () => {
      findoutmore.setDirection(directionFind);
      findoutmore.play();
    });

      findout.addEventListener('mouseleave', () => {
      findoutmore.setDirection(-directionFind);
      findoutmore.stop();
    }); 
  
    // On animation complete
    lottie.onComplete = function(){

      // On complete, proceed to next .step
      console.log('complete');
      });
   
    }*/
    
    // load all large find out more button animations
var loader = document.getElementsByClassName('findout');

function loadBMAnimation(loader) {
  var animation = lottie.loadAnimation({
    container: loader,
    renderer: 'svg',
    loop: false,
    autoplay: false,
    path: '/wp-content/uploads/json/FindOutMore_Btn_Trans_New.json',
  });
  loader.addEventListener('mouseenter', function() {
    animation.play();
    $(this).parent().find('.wpcf7-submit').addClass('highlighted');
  });
  loader.addEventListener('mouseleave', function() {
    animation.stop();
    $(this).parent().find('.wpcf7-submit').removeClass('highlighted');
  });
}

for (var i = 0; i < loader.length; i++) {
  loadBMAnimation(loader[i]);
}
 
    
    
    // carousel arrows
    $(document).ready(function () {
    var arrowLoader = document.getElementsByClassName('ani-arrow');

function loadarrowAnimation(arrowLoader) {
  var animation = lottie.loadAnimation({
    container: arrowLoader,
    renderer: 'svg',
    loop: false,
    autoplay: false,
    path: '/wp-content/uploads/json/Arrow_Btn_trans.json',
  });
  arrowLoader.addEventListener('mouseenter', function() {
    animation.play();
  });
  arrowLoader.addEventListener('mouseleave', function() {
    animation.stop();
  });
}

for (var ia = 0; ia < arrowLoader.length; ia++) {
  loadarrowAnimation(arrowLoader[ia]);
}
    });
    
    // you tube / insta arrows
      $(document).ready(function () {
    var smashLoader = document.getElementsByClassName('sby-owl-prev');

function loadarrowAnimation(smashLoader) {
  var animation = lottie.loadAnimation({
    container: smashLoader,
    renderer: 'svg',
    loop: false,
    autoplay: false,
    path: '/wp-content/uploads/json/Arrow_Btn_trans.json',
  });
  smashLoader.addEventListener('mouseenter', function() {
    animation.play();
  });
  smashLoader.addEventListener('mouseleave', function() {
    animation.stop();
  });
}

for (var ias = 0; ias < smashLoader.length; ias++) {
  loadarrowAnimation(smashLoader[ias]);
}
    });
    $(document).ready(function () {
    var smashLoader = document.getElementsByClassName('sby-owl-next');

function loadarrowAnimation(smashLoader) {
  var animation = lottie.loadAnimation({
    container: smashLoader,
    renderer: 'svg',
    loop: false,
    autoplay: false,
    path: '/wp-content/uploads/json/Arrow_Btn_trans.json',
  });
  smashLoader.addEventListener('mouseenter', function() {
    animation.play();
  });
  smashLoader.addEventListener('mouseleave', function() {
    animation.stop();
  });
}

for (var iasa = 0; iasa < smashLoader.length; iasa++) {
  loadarrowAnimation(smashLoader[iasa]);
}
    });
    
    $(document).ready(function () {
    var smashiLoader = document.getElementsByClassName('sbi-owl-prev');

function loadarrowAnimation(smashiLoader) {
  var animation = lottie.loadAnimation({
    container: smashiLoader,
    renderer: 'svg',
    loop: false,
    autoplay: false,
    path: '/wp-content/uploads/json/Arrow_Btn_trans.json',
  });
  smashiLoader.addEventListener('mouseenter', function() {
    animation.play();
  });
  smashiLoader.addEventListener('mouseleave', function() {
    animation.stop();
  });
}

for (var iai = 0; iai < smashiLoader.length; iai++) {
  loadarrowAnimation(smashiLoader[iai]);
}
    });
    $(document).ready(function () {
    var smashiLoader = document.getElementsByClassName('sbi-owl-next');

function loadarrowAnimation(smashiLoader) {
  var animation = lottie.loadAnimation({
    container: smashiLoader,
    renderer: 'svg',
    loop: false,
    autoplay: false,
    path: '/wp-content/uploads/json/Arrow_Btn_trans.json',
  });
  smashiLoader.addEventListener('mouseenter', function() {
    animation.play();
  });
  smashiLoader.addEventListener('mouseleave', function() {
    animation.stop();
  });
}

for (var iaia = 0; iaia < smashiLoader.length; iaia++) {
  loadarrowAnimation(smashiLoader[iaia]);
}
    });
    
    var smbuttonLoader = document.getElementsByClassName('sm-button');

function loadsmbutton(smbuttonLoader) {
  var animation = lottie.loadAnimation({
    container: smbuttonLoader,
    renderer: 'svg',
    loop: false,
    autoplay: false,
    path: '/wp-content/uploads/json/More_Btn.json',
  });
  smbuttonLoader.addEventListener('mouseenter', function() {
    animation.play();
  });
  smbuttonLoader.addEventListener('mouseleave', function() {
    animation.stop();
  });
}

for (var is = 0; is < smbuttonLoader.length; is++) {
  loadsmbutton(smbuttonLoader[is]);
}
    
    // menu mobile
    var container = document.getElementById('menu');
    var state = 'close';
       var mobilemen = lottie.loadAnimation({
  // animationData: { /* ... */ },
  container: container, // required
  path: '/wp-content/uploads/json/menu.json', // required
  renderer: 'svg', // required
  loop: false, // optional
  autoplay: false, // optional
  name: 'Logo', // optional
});
    
    mobilemen.goToAndStop(64, true);
    container.addEventListener('click', function() {
       
    if(state === 'close') {
   mobilemen.playSegments([0, 32], true);
    state = 'open';
  } else {
    mobilemen.playSegments([49, 64], true);
    state = 'close';
  }
  });

    
  //  mobilemen;
    // play animations
    
   var logo = lottie.loadAnimation({
  // animationData: { /* ... */ },
  container: document.getElementById('logo'), // required
  path: '/wp-content/uploads/json/logo.json', // required
  renderer: 'svg', // required
  loop: true, // optional
  autoplay: true, // optional
  name: 'Logo', // optional
});
    
    logo;
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};






// WEBPACK FOOTER //
// ./scripts/routes/common.js